import { initializeApp } from "firebase/app";
import {
  initializeAuth,
  browserLocalPersistence,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: "AIzaSyAZLoQxVkw4YQcpBAUB8o6kbFPmqHZfnNY",
  authDomain: "build-list-omeezzii.firebaseapp.com",
  projectId: "build-list-omeezzii",
  storageBucket: "build-list-omeezzii.firebasestorage.app",
  messagingSenderId: "671844256206",
  appId: "1:671844256206:web:2c1a64c577d80b8059039f"
};

const app = initializeApp(firebaseConfig);

let auth;

if (Capacitor.isNativePlatform()) {
  auth = initializeAuth(app, {
    persistence: indexedDBLocalPersistence
  });
} else {
  auth = initializeAuth(app, {
    persistence: browserLocalPersistence,
    popupRedirectResolver: browserPopupRedirectResolver
  });
}

export { auth };

export const db = getFirestore(app);
export const storage = getStorage(app);